import { LayoutStrategyProvider, LayoutStrategyProviderParams } from './layoutStrategyProvider';

export class DashboardStrategyProvider implements LayoutStrategyProvider {
    constructor(private readonly params: LayoutStrategyProviderParams) {}

    shouldApply(): boolean {
        const { user } = this.params;

        return user?.organizations?.length > 0;
    }
}
